<div class="main-screen-container">
    <div class="top-row">
        <button mat-flat-button class="btn-action btn-with-icon" color="accent"
            (click)="router.navigate(['organizations-list'])"><img style="width:25px;" src="/assets/img/back.png"
                alt="">Powrót</button>
        <button mat-flat-button class="btn-action btn-with-icon" color="accent"
            (click)="removeOrganization()"><mat-icon>delete_outline</mat-icon> Usuń organizację</button>

    </div>
    <mat-card class="list-container">
        <mat-card-content>
            <div class="row">
                <div class="col">
                    <div class="add-form">
                        <h3>Edytuj organizację</h3>
                        <form [formGroup]="editForm" (ngSubmit)="onSubmit()" class="form-layout">
                            <input type="hidden" formControlName="id">
                            <mat-form-field appearance="outline" style="width:100%;">
                                <mat-label>Nazwa</mat-label>
                                <input matInput type="text" placeholder="Nazwa" required formControlName="name">
                            </mat-form-field>
                            <mat-form-field appearance="outline" style="width:100%;">
                                <mat-label>Adres</mat-label>
                                <input matInput type="adres" placeholder="Adres" required formControlName="address">
                            </mat-form-field>
                            <mat-form-field appearance="outline" style="width:100%;">
                                <mat-label>NIP</mat-label>
                                <input matInput type="text" placeholder="NIP" required formControlName="nip">
                            </mat-form-field>
                            <button mat-flat-button class="btn-action btn-large" color="accent">Zapisz</button>
                        </form>
                    </div>
                </div>
                <div class="col-9">
                    <app-rekbot-list-small [selectedRekbotsIds]="selectedRekbotsIds"></app-rekbot-list-small>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
    <div style="height:50px">

    </div>
</div>